/**
 * Gets a comma seperated list of layers and returns the layer names required for printing.
 */

export default function setPrintMapLayers(layers, dlayers, dlayerList, usertype) {

    let productName = '';
    const arrLayers = layers.split(",");
    arrLayers.forEach(function (l) {
        if (productName !== ''){ productName += ','; } 
        productName += getlayername(l, usertype);
    });
    //console.log("dlayers length "+JSON.stringify(dlayers));
    //console.log("dlayers length "+dlayers.length);
    
    if (dlayers.length > 0){
        let dataLabel = '';
        dlayers.forEach(function (d) {

            dlayerList.forEach(function (dl) {
                //console.log("d "+d+" dl.productcode "+dl.productcode);
                if(dl.productcode === d){
                    if (dataLabel !== ''){ dataLabel += ','; }
                    dataLabel += dl.layer;
                }
            });
        });
        productName += ','+dataLabel;
    }
    //sState.dlayerList
    //console.log("productName "+productName);
    return productName;
}

function getlayername(layer, usertype){

    let productName = '';
    switch (layer){
        case "osmmbw":
            let osmmbwLayer = process.env.REACT_APP_LAYER_OSMMBW;
            if (usertype === 'gia') { osmmbwLayer = process.env.REACT_APP_LAYER_GIA_OSMMBW; }
            productName = osmmbwLayer;
            break;
        case "osmm":
            let osmmLayer = process.env.REACT_APP_LAYER_OSMM;
            if (usertype === 'gia') { osmmLayer = process.env.REACT_APP_LAYER_GIA_OSMM; }
            productName = osmmLayer;
            break;
        case "os10k":
            productName = process.env.REACT_APP_LAYER_10k;
            break;
        case "osvml":
            productName = process.env.REACT_APP_LAYER_VML;
            break;
        case "os25k":
            productName = process.env.REACT_APP_LAYER_25k;
            break;
        case "os50k":                
            productName = process.env.REACT_APP_LAYER_50k;
            break;
        case "os250k":
            productName = process.env.REACT_APP_LAYER_250k
            break;
        case "aerial":
            productName = process.env.REACT_APP_LAYER_AERIAL;
            break;
        default:
        break;
    }
    return productName;

}
  